'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

export const GTMPageViewTracker = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (!window.dataLayer) {
        window.dataLayer = [];
        console.warn('⚠️ GTM dataLayer not found. Initialized empty dataLayer.');
      }
      const url = pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '');
      
      let pageType = 'other';
      let pageCategory = 'general';
      
      if (pathname.includes('/competitions')) {
        pageCategory = 'competitions';
        if (pathname.includes('/match/')) {
          pageType = 'match-detail';
        } else if (pathname.includes('/club/')) {
          pageType = 'club-detail';
        } else if (pathname.includes('/association/')) {
          pageType = 'association-detail';
        } else if (pathname.match(/\/competitions\/\d+$/)) {
          pageType = 'competition-detail';
        } else {
          pageType = 'competitions-list';
        }
      } else if (pathname.includes('/match')) {
        pageCategory = 'matches';
        pageType = 'match';
      } else if (pathname === '/') {
        pageCategory = 'competitions';
        pageType = 'competitions';
      }
      const pageViewEvent = {
        event: 'page_view',
        page_path: url,
        page_title: document.title || pathname,
        page_location: window.location.href,
        page_type: pageType,
        page_category: pageCategory,
        'page': pageType,
        'category': pageCategory,
        'section': pathname,
        timestamp: new Date().toISOString(),
      };

      window.dataLayer.push(pageViewEvent);
    } else {
      console.warn('⚠️ Window object not available. GTM page view events not tracked.');
    }
  }, [pathname, searchParams]);

  return null;
};

